import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import { useIntl } from 'react-intl';

const AdminTaxonomyEditTabs = ({
  activeTab,
  handleSwitchTab,
}) => {
  const intl = useIntl();

  return (
    <Nav tabs className="settings-tabs icon-tabs">
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'details' })}
          onClick={() => { handleSwitchTab('details'); }}
        >
          <i className="fa-solid fa-memo" />
          <span>{intl.formatMessage({ defaultMessage: 'Details' })}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'settings' })}
          onClick={() => { handleSwitchTab('settings'); }}
        >
          <i className="fa-solid fa-gear" />
          <span>{intl.formatMessage({ defaultMessage: 'Settings' })}</span>
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className={classnames({ active: activeTab === 'metadata-groups' })}
          onClick={() => { handleSwitchTab('metadata-groups'); }}
        >
          <i className="far fa-folder-open" />
          <span>{intl.formatMessage({ defaultMessage: 'Metadata Groups' })}</span>
        </NavLink>
      </NavItem>
    </Nav>
  );
};

AdminTaxonomyEditTabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  handleSwitchTab: PropTypes.func.isRequired,
};

export default AdminTaxonomyEditTabs;
